<template>
    <div v-if="studentOpportunity">
    <b-container class="main-container">

        <h3>PIP Submission -
            {{ studentOpportunity.student.fullName
                ? studentOpportunity.student.fullName
                : studentOpportunity.student.firstName + " " + studentOpportunity.student.lastName }}

            - {{ studentOpportunity.opportunity.term.description }} </h3>
        <h5>Student Opportunity Id: {{ studentOpportunity.studentOpportunityId }}</h5>

        <!-- <h3>PIP Details Page for Student Opportunity {{ studentOpportunityId }} -->
        <!-- </h3> -->

        <!-- <pre>
              {{ studentOpportunity }}
        </pre> -->

        <!-- Student info -->
        <widget heading="Student Information">
            <!-- <b-row>
                <b-col class="col-md-12">
                    <h3>Student Information</h3>
                </b-col>
            </b-row> -->

            <b-row>
                <b-col class="col-md-12">
                    <dl>
                        <dt>Name</dt>
                        <dd>
                            {{ studentOpportunity.student.fullName
                                ? studentOpportunity.student.fullName
                                : studentOpportunity.student.firstName + " " + studentOpportunity.student.lastName }}
                        </dd>

                        <dt>Email</dt>
                        <dd>
                            <a :href="'mailto:' + studentOpportunity.student.asuEmailAddress">{{
                                studentOpportunity.student.asuEmailAddress
                            }}</a>
                        </dd>

                        <dt>Current Program(s)</dt>
                        <dd>{{ activePlan.academicPlan }} - {{ activePlan.academicPlanDescription }}</dd>

                        <dt>Current Semester</dt>
                        <dd>{{ studentOpportunity.opportunity.term.description }}</dd>
                    </dl>
                </b-col>
            </b-row>
        </widget>

        <!-- Site info -->
        <widget heading="Site Information">

            <!-- <b-row>
                <b-col class="col-md-12">
                    <P></P>
                    <h3>Site Information</h3>
                </b-col>
            </b-row> -->

            <b-row>
                <b-col class="col-md-3">
                    <dl>
                        <dt>Name:</dt>

                        <dd>
                            {{ studentOpportunity.opportunity.site.name }}
                        </dd>

                        <dt>
                            Address
                        </dt>

                        <dd> {{ studentOpportunity.opportunity.site.streetAddress + ", " +
                            studentOpportunity.opportunity.site.city + ", " +
                            studentOpportunity.opportunity.site.state
                            + ", " +
                            studentOpportunity.opportunity.site.zip }}
                        </dd>

                        <dt>
                            Website
                        </dt>

                        <dd>
                            <a :href="studentOpportunity.opportunity.site.website" target="_blank">
                                {{ studentOpportunity.opportunity.site.website }}
                            </a>
                        </dd>

                        <dt>
                            Phone
                        </dt>

                        <dd>
                            {{ studentOpportunity.opportunity.site.phone }}
                        </dd>
                    </dl>
                </b-col>
            </b-row>
        </widget>

        <widget heading="Site Contact Information">
            <!-- <b-row>
                <b-col class="col-md-12">
                    <P></P>
                    <h3>Site Contact Information</h3>
                </b-col>
            </b-row> -->

            <b-row v-for="c in studentOpportunity.studentOpportunityContacts"
                :key="c.studentOpportunityContactId || c.siteContactId">

                <b-col class="col-md-12">
                    <dl>
                        <dt>
                            Name
                        </dt>

                        <dd>
                            <a :href="'mailto:' + c.siteContact.email">{{ c.siteContact.firstName }} {{
                                c.siteContact.lastName }}</a>
                        </dd>

                        <dt>
                            Title
                        </dt>

                        <dd>
                            {{ c.siteContact.title }}
                        </dd>

                        <dt>
                            Phone Number
                        </dt>

                        <dd>
                            {{ c.siteContact.phoneNumber }}
                        </dd>
                    </dl>
                </b-col>
            </b-row>
        </widget>

        <!-- Job Details -->
        <widget heading="Job Details">

            <!-- <b-row>
                <b-col class="col-md-12">
                    <P></P>
                    <h3>Job Details</h3>
                </b-col>
            </b-row> -->

            <b-row>
                <b-col class="col-md-3">
                    <dl>
                        <dt>
                            Physical Address
                        </dt>

                        <dd>
                            {{ studentOpportunity.otherAddress }}
                        </dd>

                        <dt>
                            Paid position?
                        </dt>

                        <dd>
                            {{ studentOpportunity.isPaid == false ? "No" : "Yes" }}
                        </dd>

                        <dt>
                            Student current employee?
                        </dt>
                        <dd>
                            {{ studentOpportunity.isCurrentEmployee == false ? "No" : "Yes" }}
                        </dd>

                        <dt>
                            Job Title
                        </dt>

                        <dd>
                            {{ studentOpportunity.jobTitle }}
                        </dd>
                    </dl>
                </b-col>
            </b-row>
        </widget>

        <!-- Goals -->
        <widget heading="Goals">
            <b-row>
                <b-col class="col-md-3">
                    <ol>
                        <li v-for="g in studentOpportunity.goals" :key="g.goalId">
                            {{ g.text }}
                        </li>
                    </ol>
                </b-col>
            </b-row>
        </widget>

        <widget>
            <b-row>
                <b-col class="col-md-12">
                    <P></P>
                    <h3>PIP Impact</h3>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="col-md-3">
                    <dl>
                        <dd>
                            {{ studentOpportunity.objective }}
                        </dd>
                    </dl>
                </b-col>
            </b-row>
        </widget>
    </b-container>
    </div>
</template>



<script>
import { mapActions, mapState } from "vuex";
import StudentInformation from "../../components/students/student-information";
import OpportunityInformation from "../../components/students/opportunity-information";
import AdditionalMaterial from "../../components/students/additional-material";
import StudentNotes from "../../components/students/student-notes";
import SiteContacts from "../../components/sites/site-contacts";
import Widget from "../../components/widget";
import MapDisplay from "../../components/map-display";
import studentOpportunityApi from "../../api/studentOpportunity";
import studentsApi from "../../api/students";
import SiteContracts from "../../components/sites/site-contracts";
import roleChecks from "../../misc/role-checks";
import ContactForm from "../../components/sites/contact-form";
import CourseForm from "../../components/students/course-form";
import DatesForm from "../../components/students/dates-form";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";

export default {
  data() {
    return {
      studentOpportunity: null,
      additionalMaterialStatuses: [],
      notes: [],
      show: false,
      showCourseModal: false,
      showHoursModal: false,
      course: {},
      student: null,
    };
  },

  components: {
    "student-information": StudentInformation,
    "opportunity-information": OpportunityInformation,
    "additional-material": AdditionalMaterial,
    "student-notes": StudentNotes,
    "site-contacts": SiteContacts,
    widget: Widget,
    "map-display": MapDisplay,
    "site-contracts": SiteContracts,
    "contact-form": ContactForm,
    CourseForm,
    DatesForm,
  },

  props: {
    studentOpportunityId: {
      required: true,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    currentPlans() {
      var currentTerm = this.terms[0];
      var filteredPlans = _.filter(this.student.studentPlans, (plan) => {
        return plan.termCode == currentTerm.termCode;
      });
      return filteredPlans;
    },
    activePlan() {
      if (this.student) {
        const studentPlans = this.student.studentPlans;
        if (this.student.studentPlans) {
          const latestTerm = studentPlans.sort((a, b) =>
            b.termCode.localeCompare(a.termCode),
          )[0].termCode;

          return this.student.studentPlans.find(
            (plan) =>
              plan.termCode === latestTerm && plan.primaryRecord === "Y",
          );
        }
      }
    },
    showDeadlineAlert: function() {
      return (
        this.studentOpportunity.opportunityType &&
        (this.studentOpportunity.opportunityType.name == "Internship" ||
          (this.studentOpportunity.opportunityType.name ==
            "Translational Team" &&
            (this.studentOpportunity.opportunityCategory.name == "Credit" ||
              this.studentOpportunity.opportunityCategory.name ==
                "Paid Credit")))
      );
    },

    hasSelectedCourse: function() {
      if (!this.studentOpportunity.studentView) {
        return false;
      }

      const subjectCode = this.studentOpportunity.subjectCode;
      const catalogNumber = this.studentOpportunity.catalogNumber;
      const scheduleLineNumber = this.studentOpportunity.scheduleLineNumber;
      return (
        _.filter(
          this.studentOpportunity.studentView.studentCourses,
          (course) => {
            return (
              course.subjectCode === subjectCode.trim() &&
              course.catalogNumber === catalogNumber.trim() &&
              course.classNumber === scheduleLineNumber
            );
          },
        ).length > 0
      );
    },

    hasInternshipCourse: function() {
      if (!this.studentOpportunity.studentView) {
        return false;
      }
      return (
        _.filter(
          this.studentOpportunity.studentView.studentCourses,
          (course) => {
            return (
              _.filter(
                this.studentOpportunity.opportunity
                  .opportunityInternshipCourses,
                (oic) => {
                  return (
                    course.subjectCode === oic.internshipCourse.subjectCode &&
                    course.catalogNumber ===
                      oic.internshipCourse.catalogNumber.toString()
                  );
                },
              ).length > 0
            );
          },
        ).length > 0
      );
    },

    contracts: function() {
      if (this.studentOpportunity.opportunity) {
        return _.map(
          this.studentOpportunity.opportunity.site.contractSites,
          function(contractSite) {
            return contractSite.contract;
          },
        );
      }
      return [];
    },

    contact: function() {
      var contacts = _.map(
        this.studentOpportunity.studentOpportunityContacts,
        function(studentOpportunityContact) {
          return studentOpportunityContact.siteContact;
        },
      );
      if (contacts.length) {
        return contacts[0];
      }
    },

    hasAddress: function() {
      return (
        this.studentOpportunity &&
        (this.studentOpportunity.opportunity.site.streetAddress ||
          this.studentOpportunity.opportunity.site.city ||
          this.studentOpportunity.opportunity.site.state ||
          this.studentOpportunity.opportunity.site.zip)
      );
    },
  },

  methods: {
    getStudentOpportunity: function() {
      var that = this;
      studentOpportunityApi
        .getStudentOpportunityById(this.studentOpportunityId)
        .then(function(response) {
          that.studentOpportunity = response.data;

          studentsApi
            .getStudentByAsuriteId(response.data.asuriteId)
            .then(function(response) {
              that.student = response.data;
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },

  created() {
    this.getStudentOpportunity();
  },
};
</script>
